(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[71698,18740,31701,69655,14777,25591,84043,60681,65250,74206,52892],{

/***/ 13219:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ FullCoverageWarrantyWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/footer/index.tsx
var footer = __webpack_require__(31701);
// EXTERNAL MODULE: ./src/components/shared/modal/index.tsx
var shared_modal = __webpack_require__(18740);
// EXTERNAL MODULE: ./src/components/svg/closeIcon.tsx
var closeIcon = __webpack_require__(69655);
// EXTERNAL MODULE: ./src/components/shared/legal/privacyPolicy.tsx + 1 modules
var privacyPolicy = __webpack_require__(57079);
// EXTERNAL MODULE: ./src/components/shared/legal/termsAndConditions.tsx + 1 modules
var termsAndConditions = __webpack_require__(10761);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
;// CONCATENATED MODULE: ./src/components/fullcoveragewarranty/logo/index.tsx


function FullCoverageWarrantyLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "388",
        height: "45",
        fill: "none",
        viewBox: "0 0 388 45",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_0_18)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M66.229 19.782h-8.583v5.501h7.177c.664 0 1.165.15 1.49.45.326.298.495.695.495 1.196 0 .5-.17.897-.501 1.19-.332.292-.827.442-1.484.442h-7.177v7.081c0 .898-.202 1.568-.612 2.003-.403.436-.924.65-1.562.65-.637 0-1.17-.22-1.574-.663-.404-.442-.612-1.105-.612-1.996V19.093c0-.625.091-1.138.28-1.535.189-.397.475-.683.872-.865.397-.182.904-.273 1.516-.273h10.275c.696 0 1.21.156 1.548.462.339.305.508.708.508 1.21 0 .5-.17.916-.508 1.222-.338.305-.852.461-1.548.461v.007zM81.65 36.033v-.514a9.342 9.342 0 01-1.51 1.528 5.614 5.614 0 01-1.73.917c-.625.202-1.34.3-2.141.3-.97 0-1.835-.202-2.603-.599a4.438 4.438 0 01-1.783-1.658c-.501-.852-.748-2.075-.748-3.668v-7.933c0-.8.182-1.398.54-1.795.364-.397.84-.592 1.438-.592.599 0 1.093.202 1.47.598.371.403.56.995.56 1.789v6.412c0 .93.078 1.71.234 2.34.157.631.436 1.125.846 1.483.41.358.957.533 1.653.533.696 0 1.308-.201 1.907-.598a3.514 3.514 0 001.308-1.567c.227-.566.338-1.808.338-3.726v-4.87c0-.794.189-1.393.56-1.79.37-.402.858-.598 1.45-.598.593 0 1.074.196 1.439.592.364.397.54.995.54 1.795v11.601c0 .761-.176 1.333-.52 1.717-.346.384-.795.572-1.341.572-.547 0-1.002-.195-1.36-.591-.358-.397-.534-.95-.534-1.665l-.013-.013zM89.4 35.857v-17.37c0-.799.176-1.41.533-1.82.358-.41.84-.618 1.445-.618.605 0 1.093.202 1.47.612.378.41.56 1.014.56 1.827v17.37c0 .812-.189 1.417-.566 1.826-.377.404-.865.612-1.457.612-.593 0-1.068-.208-1.432-.631-.364-.423-.553-1.021-.553-1.801v-.007zM97.547 35.857v-17.37c0-.799.176-1.41.533-1.82.358-.41.84-.618 1.445-.618.605 0 1.093.202 1.471.612.377.41.559 1.014.559 1.827v17.37c0 .812-.189 1.417-.566 1.826-.377.404-.865.612-1.458.612-.592 0-1.067-.208-1.431-.631-.364-.423-.553-1.021-.553-1.801v-.007zM131.813 31.136c0 .683-.169 1.424-.508 2.224-.338.8-.865 1.58-1.594 2.348-.722.767-1.646 1.391-2.772 1.873-1.126.48-2.433.721-3.93.721-1.132 0-2.167-.11-3.097-.325a8.628 8.628 0 01-2.532-1.008 8.428 8.428 0 01-2.088-1.794 10.597 10.597 0 01-1.451-2.264 12.037 12.037 0 01-.905-2.679 14.512 14.512 0 01-.299-3.023c0-1.73.253-3.278.755-4.65.501-1.366 1.223-2.543 2.166-3.512a9.519 9.519 0 013.299-2.224c1.263-.507 2.61-.76 4.035-.76 1.744 0 3.292.344 4.652 1.04 1.36.696 2.401 1.554 3.124 2.575.722 1.021 1.086 1.99 1.086 2.894 0 .5-.175.936-.527 1.32a1.67 1.67 0 01-1.275.572c-.56 0-.976-.13-1.256-.396-.28-.267-.592-.716-.93-1.366-.567-1.067-1.237-1.86-2.005-2.393-.767-.527-1.717-.794-2.837-.794-1.789 0-3.214.683-4.281 2.042-1.061 1.36-1.595 3.29-1.595 5.795 0 1.67.235 3.062.703 4.174.469 1.112 1.132 1.938 1.998 2.485.859.546 1.867.819 3.026.819 1.249 0 2.31-.312 3.175-.93.866-.618 1.516-1.535 1.959-2.738.188-.566.416-1.027.689-1.385.274-.358.716-.533 1.321-.533.521 0 .963.182 1.334.54.371.364.56.813.56 1.352zM150.456 30.154c0 1.19-.189 2.296-.56 3.297a7.267 7.267 0 01-1.614 2.595 7.115 7.115 0 01-2.524 1.665c-.976.383-2.083.578-3.299.578-1.217 0-2.304-.195-3.273-.585a7.2 7.2 0 01-4.132-4.26c-.365-.994-.554-2.087-.554-3.29 0-1.203.189-2.321.56-3.33a7.225 7.225 0 011.601-2.58c.696-.716 1.535-1.262 2.525-1.652.989-.384 2.075-.58 3.273-.58 1.197 0 2.316.196 3.299.586.989.39 1.835.95 2.537 1.671a7.23 7.23 0 011.608 2.582c.364.995.553 2.1.553 3.297v.006zm-4.022 0c0-1.632-.358-2.907-1.08-3.81-.722-.904-1.685-1.366-2.895-1.366-.781 0-1.471.202-2.07.611-.598.404-1.054 1.002-1.379 1.795-.325.793-.482 1.717-.482 2.77 0 1.054.157 1.964.475 2.744.319.78.775 1.38 1.367 1.795.592.416 1.288.625 2.089.625 1.21 0 2.179-.456 2.895-1.372.716-.917 1.08-2.179 1.08-3.792zM156.045 24.503l3.24 9.091 3.495-9.488c.273-.76.54-1.3.807-1.619.266-.319.663-.475 1.203-.475.508 0 .944.17 1.302.514.358.345.533.741.533 1.19 0 .176-.032.384-.097.618a5.46 5.46 0 01-.222.657c-.084.208-.175.442-.286.702l-3.845 9.533c-.111.273-.248.624-.417 1.04-.169.423-.364.781-.573 1.08a2.16 2.16 0 01-.78.696c-.306.17-.684.247-1.126.247-.566 0-1.022-.13-1.36-.39-.338-.26-.586-.54-.748-.852-.163-.312-.436-.917-.814-1.827l-3.813-9.43c-.091-.234-.176-.468-.273-.702a6.683 6.683 0 01-.234-.722 2.492 2.492 0 01-.098-.63c0-.274.085-.547.247-.813.169-.267.397-.488.69-.657.293-.17.612-.26.957-.26.663 0 1.125.188 1.372.572.248.384.528 1.021.827 1.919l.013.006zM180.29 31.136h-7.834c.006.91.188 1.71.553 2.406.358.696.833 1.216 1.425 1.567a3.762 3.762 0 001.958.527 4.88 4.88 0 001.315-.169c.397-.11.781-.286 1.152-.527a9.04 9.04 0 001.028-.767c.312-.273.722-.644 1.217-1.112.208-.175.501-.267.878-.267.41 0 .742.111 1.002.339.254.227.384.54.384.956 0 .364-.143.786-.423 1.268-.286.48-.709.949-1.282 1.391-.572.442-1.288.813-2.154 1.106-.865.292-1.861.442-2.986.442-2.577 0-4.575-.735-6-2.198-1.431-1.47-2.141-3.46-2.141-5.97 0-1.183.176-2.282.527-3.29.352-1.015.866-1.88 1.543-2.601a6.662 6.662 0 012.492-1.665c.989-.384 2.082-.579 3.286-.579 1.568 0 2.908.332 4.028.989 1.119.656 1.958 1.515 2.518 2.562.559 1.047.839 2.113.839 3.2 0 1.007-.293 1.657-.865 1.957-.579.299-1.386.448-2.434.448l-.026-.013zm-7.834-2.276h7.262c-.098-1.365-.469-2.393-1.107-3.076-.637-.682-1.483-1.02-2.531-1.02-1.047 0-1.815.344-2.46 1.033-.644.69-1.028 1.71-1.164 3.057v.006zM190.949 32.515v3.342c0 .813-.189 1.418-.573 1.828a1.92 1.92 0 01-1.451.61c-.586 0-1.054-.207-1.425-.617-.371-.41-.56-1.014-.56-1.82V24.71c0-1.8.651-2.698 1.953-2.698.663 0 1.145.208 1.438.63.292.423.455 1.04.481 1.86.482-.82.97-1.443 1.477-1.86.501-.422 1.178-.63 2.017-.63.84 0 1.66.208 2.454.63.793.423 1.19.976 1.19 1.672 0 .487-.169.89-.507 1.21-.339.318-.703.474-1.093.474-.15 0-.501-.091-1.061-.273-.566-.182-1.061-.273-1.49-.273-.586 0-1.067.156-1.438.461-.371.306-.657.768-.866 1.372-.208.605-.345 1.327-.423 2.166a33.694 33.694 0 00-.117 3.056l-.006.007zM209.513 36.032c-.969.755-1.906 1.32-2.811 1.691-.904.377-1.919.566-3.045.566-1.028 0-1.933-.202-2.707-.611-.781-.403-1.379-.956-1.796-1.652a4.268 4.268 0 01-.631-2.257c0-1.092.345-2.028 1.041-2.802s1.646-1.288 2.863-1.554c.254-.059.885-.189 1.894-.397a76.148 76.148 0 002.59-.566c.722-.169 1.496-.377 2.342-.624-.052-1.054-.26-1.834-.638-2.328-.377-.494-1.158-.742-2.342-.742-1.015 0-1.783.144-2.297.423-.514.286-.957.709-1.321 1.275s-.625.943-.781 1.125c-.15.182-.475.273-.976.273-.449 0-.839-.143-1.165-.436a1.409 1.409 0 01-.488-1.105c0-.703.248-1.392.749-2.055.501-.663 1.275-1.21 2.336-1.645 1.054-.43 2.375-.644 3.949-.644 1.764 0 3.143.208 4.152.624 1.008.416 1.718 1.073 2.134 1.97.417.898.625 2.094.625 3.577 0 .936 0 1.736-.007 2.393 0 .657-.013 1.385-.019 2.185 0 .754.123 1.535.377 2.354.247.82.378 1.34.378 1.574 0 .41-.196.787-.58 1.125a1.938 1.938 0 01-1.314.507c-.41 0-.813-.195-1.217-.579-.403-.383-.826-.943-1.275-1.678l-.02.014zm-.266-5.793c-.586.214-1.439.442-2.564.682-1.119.24-1.894.416-2.33.527-.436.11-.839.332-1.23.663-.39.332-.585.787-.585 1.372 0 .586.228 1.125.69 1.548.462.423 1.06.637 1.802.637a4.72 4.72 0 002.193-.52c.67-.345 1.165-.793 1.477-1.34.364-.604.54-1.606.54-2.99v-.573l.007-.007zM231.585 24.945V36.58c0 1.333-.143 2.47-.423 3.433-.286.956-.735 1.75-1.366 2.374-.631.624-1.445 1.092-2.46 1.392-1.015.305-2.271.455-3.78.455-1.38 0-2.616-.195-3.696-.579-1.087-.384-1.92-.884-2.512-1.496-.586-.611-.879-1.242-.879-1.886 0-.487.17-.884.501-1.196a1.722 1.722 0 011.204-.462c.586 0 1.1.26 1.542.78.215.267.436.534.671.8.227.267.481.501.761.69.28.188.612.331 1.002.422.391.092.839.137 1.354.137 1.034 0 1.841-.143 2.414-.436.572-.286.976-.689 1.203-1.21.228-.52.365-1.072.404-1.664.039-.592.065-1.541.084-2.855-.618.859-1.327 1.515-2.134 1.964-.807.449-1.77.676-2.882.676-1.341 0-2.512-.344-3.514-1.027-1.002-.683-1.777-1.645-2.31-2.874-.534-1.23-.807-2.654-.807-4.266 0-1.203.163-2.29.488-3.258.325-.97.794-1.782 1.399-2.452a5.93 5.93 0 012.102-1.502c.794-.338 1.666-.507 2.609-.507 1.132 0 2.115.215 2.948.65.833.436 1.607 1.119 2.316 2.049v-.54c0-.696.169-1.23.514-1.613.345-.384.781-.572 1.321-.572.775 0 1.289.253 1.542.754.254.5.384 1.23.384 2.179v.006zm-11.608 5.072c0 1.626.351 2.849 1.067 3.681.709.832 1.627 1.249 2.752 1.249.664 0 1.295-.176 1.887-.534.593-.357 1.074-.897 1.445-1.612.371-.722.56-1.594.56-2.621 0-1.632-.358-2.907-1.081-3.81-.722-.905-1.665-1.366-2.837-1.366-1.171 0-2.062.435-2.752 1.307-.69.871-1.035 2.107-1.035 3.713l-.006-.007zM246.07 31.136h-7.835c.007.91.196 1.71.553 2.406.358.696.833 1.216 1.425 1.567a3.766 3.766 0 001.959.527 4.88 4.88 0 001.315-.169c.396-.11.78-.286 1.151-.527.371-.24.716-.494 1.028-.767.313-.273.723-.644 1.217-1.112.208-.175.501-.267.879-.267.41 0 .741.111.995.339.254.227.384.54.384.956 0 .364-.143.786-.423 1.268-.286.48-.709.949-1.282 1.391-.572.442-1.288.813-2.16 1.106-.872.292-1.861.442-2.987.442-2.577 0-4.574-.735-5.999-2.198-1.432-1.47-2.141-3.46-2.141-5.97 0-1.183.176-2.282.527-3.29.351-1.015.865-1.88 1.542-2.601a6.726 6.726 0 012.492-1.665c.989-.384 2.083-.579 3.286-.579 1.569 0 2.909.332 4.028.989 1.119.656 1.959 1.515 2.518 2.562.56 1.047.84 2.113.84 3.2 0 1.007-.286 1.657-.866 1.957-.579.299-1.392.448-2.433.448l-.013-.013zm-7.835-2.276h7.262c-.097-1.365-.468-2.393-1.106-3.076-.638-.676-1.484-1.02-2.531-1.02-1.048 0-1.816.344-2.46 1.033-.644.69-1.028 1.71-1.165 3.057v.006zM272.169 34.537l-3.481-12.895-3.52 12.895c-.273.975-.488 1.678-.651 2.107-.162.422-.442.806-.846 1.144-.403.339-.937.508-1.6.508-.541 0-.983-.098-1.328-.3a2.312 2.312 0 01-.846-.852c-.214-.364-.39-.8-.527-1.306-.136-.501-.26-.97-.364-1.399l-3.579-14.475c-.215-.839-.325-1.483-.325-1.918a1.9 1.9 0 01.585-1.412c.391-.383.879-.572 1.451-.572.794 0 1.328.254 1.601.761.273.507.514 1.249.722 2.218l2.818 12.557 3.156-11.751c.234-.898.442-1.587.631-2.055a2.95 2.95 0 01.911-1.216c.423-.338.995-.514 1.718-.514.722 0 1.301.176 1.711.533.404.358.69.748.846 1.164.156.423.364 1.112.631 2.081l3.182 11.751 2.818-12.557c.136-.657.266-1.17.39-1.541.124-.37.332-.702.631-.995.3-.293.729-.442 1.302-.442a2.01 2.01 0 011.444.565c.397.378.592.846.592 1.418 0 .403-.11 1.04-.325 1.918l-3.579 14.476c-.247.975-.449 1.69-.612 2.146a2.898 2.898 0 01-.819 1.196c-.384.345-.931.514-1.634.514-.663 0-1.197-.169-1.6-.5a2.737 2.737 0 01-.84-1.126c-.156-.416-.377-1.125-.664-2.133v.007zM294.228 36.032c-.969.755-1.906 1.32-2.811 1.691-.904.377-1.919.566-3.045.566-1.028 0-1.933-.202-2.707-.611-.781-.403-1.38-.956-1.796-1.652a4.268 4.268 0 01-.631-2.257c0-1.092.345-2.028 1.041-2.802s1.646-1.288 2.863-1.554c.254-.059.885-.189 1.894-.397a75.502 75.502 0 002.589-.566 44.77 44.77 0 002.343-.624c-.052-1.054-.26-1.834-.638-2.328-.377-.494-1.158-.742-2.342-.742-1.015 0-1.783.144-2.297.423-.514.286-.957.709-1.321 1.275-.365.566-.625.943-.781 1.125-.15.182-.475.273-.976.273-.449 0-.84-.143-1.165-.436a1.409 1.409 0 01-.488-1.105c0-.703.247-1.392.748-2.055.501-.663 1.276-1.21 2.336-1.645 1.055-.43 2.375-.644 3.95-.644 1.764 0 3.143.208 4.152.624 1.008.416 1.717 1.073 2.134 1.97.416.898.625 2.094.625 3.577 0 .936 0 1.736-.007 2.393 0 .657-.013 1.385-.019 2.185 0 .754.123 1.535.377 2.354.247.82.377 1.34.377 1.574 0 .41-.195.787-.579 1.125a1.94 1.94 0 01-1.314.507c-.41 0-.814-.195-1.217-.579-.403-.383-.826-.943-1.275-1.678l-.02.014zm-.267-5.793c-.585.214-1.438.442-2.563.682-1.12.24-1.894.416-2.33.527-.436.11-.839.332-1.23.663-.39.332-.585.787-.585 1.372 0 .586.227 1.125.689 1.548.462.423 1.061.637 1.803.637.794 0 1.522-.175 2.193-.52.67-.345 1.164-.793 1.477-1.34.364-.604.54-1.606.54-2.99v-.573l.006-.007zM305.941 32.515v3.342c0 .813-.189 1.418-.573 1.828a1.92 1.92 0 01-1.451.61c-.585 0-1.054-.207-1.425-.617-.371-.41-.559-1.014-.559-1.82V24.71c0-1.8.65-2.698 1.952-2.698.663 0 1.145.208 1.438.63.293.423.455 1.04.481 1.86.482-.82.97-1.443 1.477-1.86.501-.422 1.178-.63 2.018-.63.839 0 1.659.208 2.453.63.794.423 1.19.976 1.19 1.672 0 .487-.169.89-.507 1.21-.338.318-.703.474-1.093.474-.15 0-.501-.091-1.061-.273-.566-.182-1.061-.273-1.49-.273-.586 0-1.067.156-1.438.461-.371.306-.657.768-.865 1.372-.209.605-.345 1.327-.423 2.166a33.29 33.29 0 00-.118 3.056l-.006.007zM318.708 32.515v3.342c0 .813-.189 1.418-.573 1.828a1.922 1.922 0 01-1.451.61c-.586 0-1.054-.207-1.425-.617-.371-.41-.56-1.014-.56-1.82V24.71c0-1.8.651-2.698 1.952-2.698.664 0 1.146.208 1.438.63.293.423.456 1.04.482 1.86.481-.82.969-1.443 1.477-1.86.501-.422 1.178-.63 2.017-.63.84 0 1.659.208 2.453.63.794.423 1.191.976 1.191 1.672 0 .487-.169.89-.507 1.21-.339.318-.703.474-1.094.474-.149 0-.501-.091-1.06-.273-.566-.182-1.061-.273-1.49-.273-.586 0-1.068.156-1.438.461-.371.306-.658.768-.866 1.372-.208.605-.345 1.327-.423 2.166a33.694 33.694 0 00-.117 3.056l-.006.007zM337.272 36.032c-.969.755-1.906 1.32-2.811 1.691-.904.377-1.919.566-3.045.566-1.028 0-1.933-.202-2.707-.611-.781-.403-1.38-.956-1.796-1.652a4.268 4.268 0 01-.631-2.257c0-1.092.345-2.028 1.041-2.802s1.646-1.288 2.863-1.554c.254-.059.885-.189 1.893-.397a75.092 75.092 0 002.59-.566 44.77 44.77 0 002.343-.624c-.052-1.054-.26-1.834-.638-2.328-.377-.494-1.158-.742-2.342-.742-1.015 0-1.783.144-2.297.423-.514.286-.957.709-1.321 1.275-.365.566-.625.943-.781 1.125-.15.182-.475.273-.976.273-.449 0-.84-.143-1.165-.436a1.409 1.409 0 01-.488-1.105c0-.703.247-1.392.748-2.055.501-.663 1.276-1.21 2.336-1.645 1.054-.43 2.375-.644 3.95-.644 1.764 0 3.143.208 4.152.624 1.008.416 1.717 1.073 2.134 1.97.416.898.625 2.094.625 3.577 0 .936 0 1.736-.007 2.393 0 .657-.013 1.385-.019 2.185 0 .754.123 1.535.377 2.354.247.82.377 1.34.377 1.574 0 .41-.195.787-.579 1.125a1.94 1.94 0 01-1.314.507c-.41 0-.814-.195-1.217-.579-.403-.383-.826-.943-1.275-1.678l-.02.014zm-.267-5.793c-.585.214-1.438.442-2.563.682-1.12.24-1.894.416-2.33.527-.436.11-.839.332-1.23.663-.39.332-.585.787-.585 1.372 0 .586.227 1.125.689 1.548.462.423 1.061.637 1.803.637.794 0 1.522-.175 2.193-.52.67-.345 1.164-.793 1.477-1.34.364-.604.54-1.606.54-2.99v-.573l.006-.007zM348.646 24.23v.481c.703-.93 1.478-1.612 2.31-2.048.84-.436 1.796-.65 2.883-.65s1.998.227 2.831.689a4.384 4.384 0 011.861 1.95c.266.489.436 1.015.514 1.588.078.565.117 1.287.117 2.172v7.452c0 .8-.182 1.411-.553 1.82-.365.41-.846.618-1.432.618-.585 0-1.08-.208-1.451-.63-.371-.423-.559-1.021-.559-1.802v-6.672c0-1.32-.183-2.328-.554-3.03-.364-.702-1.099-1.047-2.192-1.047-.716 0-1.367.215-1.953.637-.585.423-1.015 1.008-1.288 1.756-.195.598-.293 1.71-.293 3.343v5.013c0 .813-.188 1.418-.566 1.828-.377.403-.865.61-1.457.61-.593 0-1.055-.207-1.425-.63-.371-.422-.56-1.02-.56-1.801V24.302c0-.761.163-1.333.501-1.71.332-.378.787-.566 1.366-.566.352 0 .671.084.957.247.286.169.514.416.683.748.169.331.254.741.254 1.216l.006-.007zM363.385 22.364h.442v-2.406c0-.644.02-1.151.052-1.515.033-.365.13-.683.287-.943a1.86 1.86 0 01.676-.67c.293-.17.619-.254.983-.254.507 0 .969.189 1.379.572.274.254.449.566.521.93.072.364.111.885.111 1.561v2.731h1.47c.566 0 1.002.137 1.302.403.299.267.449.612.449 1.034 0 .54-.215.917-.638 1.132-.423.215-1.035.325-1.829.325h-.748v7.361c0 .625.02 1.106.065 1.444.046.338.163.611.352.82.188.207.501.311.93.311.234 0 .553-.039.957-.123.403-.085.715-.124.937-.124.325 0 .611.13.872.39.26.26.39.58.39.963 0 .644-.351 1.138-1.054 1.483-.703.344-1.718.513-3.039.513-1.249 0-2.199-.208-2.85-.63a2.946 2.946 0 01-1.269-1.743c-.202-.742-.299-1.736-.299-2.979v-7.686h-.527c-.579 0-1.015-.136-1.321-.41a1.328 1.328 0 01-.456-1.04c0-.423.156-.767.475-1.034.319-.267.781-.403 1.386-.403l-.006-.013z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M377.505 38.79l.365-.898-4.933-12.407c-.306-.715-.455-1.23-.455-1.554 0-.345.084-.657.267-.956.175-.293.416-.527.728-.703.306-.175.631-.266.963-.266.579 0 1.015.182 1.308.553.293.364.553.89.781 1.573l3.39 9.859 3.215-9.17c.253-.74.481-1.326.689-1.742.209-.423.423-.703.651-.852.228-.15.553-.221.976-.221.306 0 .592.078.872.24.28.163.495.378.644.65.15.274.228.56.228.866-.039.188-.104.448-.189.793a9.45 9.45 0 01-.325 1.04l-5.225 13.67c-.449 1.203-.892 2.145-1.321 2.828a4.327 4.327 0 01-1.711 1.574c-.71.364-1.666.553-2.87.553-1.204 0-2.056-.13-2.642-.384-.585-.253-.878-.722-.878-1.392 0-.461.136-.812.416-1.06.28-.247.69-.377 1.243-.377.215 0 .423.026.631.091.254.059.475.091.657.091.462 0 .82-.071 1.087-.208.267-.136.501-.377.709-.709.209-.338.456-.832.729-1.489v.007z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#5479F7",
                        d: "M.494 17.961a2.1 2.1 0 113.215-2.705c.006.006 1.555 2.016 4.1 4.675.07.078.156.156.247.241l.097.098c.644.565 1.27.793 1.835.76.644-.045 1.321-.422 1.972-1.04.13-.124.228-.221.286-.28C17.972 13.526 28.56.793 28.586.754a2.12 2.12 0 012.973-.266 2.117 2.117 0 01.267 2.972c-.033.039-10.477 12.609-16.489 19.105-.189.202-.345.364-.462.481-1.354 1.294-2.922 2.081-4.594 2.198-1.672.11-3.358-.448-4.939-1.847-.045-.039-.09-.071-.136-.117a7.056 7.056 0 01-.443-.442C2.232 20.192.507 17.974.501 17.961H.494z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#000",
                        d: "M25.358 32.475a2.842 2.842 0 004.008-.312l6.989-8.233a2.84 2.84 0 10-4.314-3.694l-6.99 8.233a2.841 2.841 0 00.313 4.006h-.006zM18.948 28.047c.514.448 1.178.69 1.861.69.827 0 1.607-.359 2.154-.983l7.665-8.896a2.84 2.84 0 00-.286-4.006 2.858 2.858 0 00-4.015.293l-7.665 8.896a2.809 2.809 0 00-.683 2.061c.052.755.403 1.444.976 1.945h-.007zM28.273 36.793c-.397 0-.762.11-1.048.306-2.27 1.443-4.594 2.172-7.106 2.224h-.156c-2.303 0-4.73-1.021-7.203-3.03-3.794-3.083-6.357-7.336-7.275-9.358a2.855 2.855 0 00-2.596-1.678c-.404 0-.794.084-1.165.253A2.843 2.843 0 00.3 29.27c1.126 2.477 4.256 7.666 8.876 11.425C12.688 43.55 16.313 45 19.957 45h.273c3.663-.072 6.956-1.08 10.08-3.076l.097-.065.078-.085c.787-.897.97-2.016.495-3.063-.501-1.105-1.64-1.911-2.714-1.911l.007-.007zM41.385 29.133a2.84 2.84 0 00-4.991-1.626l-4.861 5.73a2.841 2.841 0 104.32 3.693l4.861-5.73a2.82 2.82 0 00.677-2.067h-.006z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_0_18",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H387.188V45H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (FullCoverageWarrantyLogo);

// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
;// CONCATENATED MODULE: ./src/components/layouts/fullCoverageWarrantyWrapper.tsx












function FullCoverageWarrantyWrapper({ children , headerBoxShadow ="" , removePadding =false  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(privacyPolicy["default"], {
                    category: "Warranty",
                    domain: "FullCoverageWarranty.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(termsAndConditions["default"], {
                    category: "Warranty",
                    domain: "FullCoverageWarranty.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Lato:wght@400;700&family=Open+Sans:wght@400;700&family=Poppins:wght@400;500;600;700&family=Roboto:wght@400;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "best warranty companies in your area",
                        boxShadow: headerBoxShadow,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: `max-w-7xl mx-auto block  ${removePadding ? "" : "px-4"} `,
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(footer["default"], {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_modal["default"], {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(closeIcon["default"], {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 31701:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Footer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67379);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(66081);
/* harmony import */ var _footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75094);








const yearNow = new Date();
function Footer({ textColor , bgColor , addCcpaPrivacyNotice  }) {
    const { setModal  } = (0,_hooks_useModalContext__WEBPACK_IMPORTED_MODULE_2__/* .useModal */ .d)();
    const { domain , pageType , locale , defaultLocale , domainNameTranslation  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { visitDetails , routeConfig , category  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const privacyPolicyLabel = category?.config?.privacyPolicyLabel ?? category?.parentCategory?.config?.privacyPolicyLabel;
    const disclaimerNote = domain?.config?.disclaimerNote ?? null;
    let contactUsLink = null;
    if (visitDetails?.trafficSourceNetwork?.toLowerCase() === "outbrain" || category?.slug === "home-security" || domain?.name === "bestcontractors.com") {
        contactUsLink = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
            className: "cursor-pointer",
            href: "/contact-us",
            children: "Contact Us"
        });
    }
    let footerLinks = [
        {
            title: domain?.translations?.[`${domainNameTranslation}_TermsConditions`] ?? "Terms & Conditions",
            onClick: ()=>setModal({
                    active: true,
                    content: "terms"
                })
        },
        {
            title: privacyPolicyLabel || domain?.translations?.[`${domainNameTranslation}_PrivacyPolicy`] || "Privacy Policy",
            onClick: ()=>setModal({
                    active: true,
                    content: "privacy"
                })
        },
        // only show partner-with-us when its not on the partner-with-us page
        ...pageType !== "partner-with-us" ? [
            {
                title: domain?.translations?.[`${domainNameTranslation}_PartnerWithUs`] ?? "Partner with Us",
                href: locale === (defaultLocale ?? "en") ? "/partner-with-us" : `/${locale}/partner-with-us`
            }, 
        ] : [], 
    ];
    if (domain?.config?.isBranded) {
        footerLinks = footerLinks.filter((link)=>link.title !== "Partner with Us");
    }
    const ccpaTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "custom-domain-ccpa-privacy-notice" || textBlock.position === "custom-category-ccpa-privacy-notice");
    if (addCcpaPrivacyNotice || ccpaTextBlock) {
        footerLinks.push({
            title: "CCPA Privacy Notice",
            onClick: ()=>setModal({
                    active: true,
                    content: "ccpaPrivacyNotice"
                })
        });
    }
    (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .injectDoNotSellInFooter */ .Du)({
        footerArray: footerLinks,
        pageType: pageType,
        trafficSource: visitDetails?.trafficSource,
        hideDoNotSell: domain.config?.hideDoNotSell,
        domain: domain,
        visitDetails: visitDetails,
        domainNameTranslation: domainNameTranslation,
        locale: locale,
        defaultLocale: defaultLocale,
        routeConfig: routeConfig
    });
    const variables = routeConfig?.config?.footer?.variables;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        style: {
            color: textColor,
            backgroundColor: bgColor,
            ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_5__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
        },
        className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().footer)}  text-center lg:px-6 lg:py-0`,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().wrapper)} max-w-7xl mx-auto`,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inner)} lg:flex lg:justify-between lg:items-center flex-row-reverse ${!bgColor ? "border-t" : ""} lg:mx-auto px-4 lg:px-0 py-6 pb-36 lg:py-4 ltrStyle`,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `footer-menu ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["footer-menu"])}`,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ul", {
                            className: "flex justify-center flex-col md:flex-row mb-3 lg:mb-0 children:last:border-r-0 ltrStyle",
                            children: [
                                footerLinks.map((item, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                        className: `px-2 pb-2 md:pb-0 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                            className: " cursor-pointer",
                                            onClick: item.onClick,
                                            href: item.href,
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                children: item.title
                                            })
                                        })
                                    }, index)),
                                contactUsLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                    className: `px-2 font-medium lg:font-light text-sm lg:leading-4 ${(_footer_module_scss__WEBPACK_IMPORTED_MODULE_6___default()["menu-item"])} `,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        children: contactUsLink
                                    })
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "font-light text-sm",
                        children: disclaimerNote ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                            dangerouslySetInnerHTML: {
                                __html: (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_4__/* .replacePlaceholders */ .wT)(disclaimerNote)
                            }
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: "\xa9"
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                    children: yearNow.getFullYear()
                                }),
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                    href: `https://${domain.name}`,
                                    children: domain.niceName
                                })
                            ]
                        })
                    })
                ]
            })
        })
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 18740:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Modal; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_dom__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73935);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(90021);
/* harmony import */ var _modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88737);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(79961);






function Modal({ children , closeIcon , width , active , backdropClosable , onClose , modalStyles , bodyStyles , header , modalClassName , wrapperClassName , pageBuilderVariables , closeButtonClassName , overflow , activeCloseOnEscButton , fontFamilyAsProp  }) {
    const { routeConfig , locale  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_3__/* .useDomainContext */ .w)();
    const { 0: mounted , 1: setMounted  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: animation , 1: setAnimation  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const startAnimation = ()=>{
        setTimeout(()=>{
            setAnimation(true);
        }, 100);
    };
    const resetAnimation = ()=>{
        setAnimation(false);
    };
    const handleEsc = (0,react__WEBPACK_IMPORTED_MODULE_1__.useCallback)((event)=>{
        if (event.key === "Escape") {
            onClose(); // close modal
        }
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (mounted) {
            if (active) {
                if (activeCloseOnEscButton) {
                    document.addEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.add("overflow-hidden");
                document.body.classList.add("overflow-hidden");
                if (window.innerWidth > 1024) {
                    document.body.style.width = "calc(100% - 15px)";
                }
                startAnimation();
            } else {
                if (activeCloseOnEscButton) {
                    document.removeEventListener("keydown", handleEsc);
                }
                document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
                document.body.classList.remove("overflow-hidden");
                document.body.style.width = "";
                resetAnimation();
            }
        }
        return ()=>{
            if (activeCloseOnEscButton) {
                document.removeEventListener("keydown", handleEsc);
            }
            document.getElementsByTagName("html")[0].classList.remove("overflow-hidden");
            document.body.classList.remove("overflow-hidden");
            document.body.style.width = "";
            resetAnimation();
        };
    }, [
        active
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        setMounted(true);
    }, []);
    const getStyleObject = ()=>{
        return {
            ...pageBuilderVariables ? {
                ...pageBuilderVariables
            } : {},
            ...fontFamilyAsProp ? {
                fontFamily: fontFamilyAsProp
            } : routeConfig ? {
                fontFamily: (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_4__/* .getFinalFontFamily */ .XR)(routeConfig, locale)
            } : {}
        };
    };
    if (mounted) {
        return /*#__PURE__*/ (0,react_dom__WEBPACK_IMPORTED_MODULE_2__.createPortal)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().wrapper)} ${active ? "flex" : "hidden"} ${wrapperClassName ?? ""}`,
                style: getStyleObject(),
                children: [
                    active && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        onClick: backdropClosable ? onClose : undefined,
                        className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().backdrop)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().modal)} ${wrapperClassName ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default())[wrapperClassName] : ""} 
                        ${modalClassName ?? ""}
                        ${overflow && overflow === "visible" ? (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["overflow-visible"]) : ""}
                        
                        duration-500 transition-all ease-in-out transform ${animation ? "-translate-y-0 opacity-100" : "-translate-y-10 opacity-0"}`,
                        style: {
                            width: width ? typeof width === "string" ? `${width}px` : width : "520px",
                            maxWidth: "calc(100vw - 32px)",
                            pointerEvents: "auto",
                            ...modalStyles
                        },
                        children: [
                            header && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().header),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: header
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: `${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default().body)} `,
                                style: bodyStyles,
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                                        onClick: onClose,
                                        type: "button",
                                        "aria-label": "Close",
                                        className: `${closeButtonClassName} ${(_modal_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["close-button"])}`,
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                            className: "close-icon",
                                            children: closeIcon
                                        })
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        style: {
                                            height: "100%"
                                        },
                                        children: children
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        }), document.body);
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
}


/***/ }),

/***/ 69655:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ CloseIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);


function CloseIcon() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "47",
        height: "47",
        fill: "none",
        viewBox: "0 0 47 47",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
            d: "M45.359 5.447A3.252 3.252 0 0045.35.85l.106.106a3.256 3.256 0 00-4.597-.009L23.865 17.941a1.003 1.003 0 01-1.424 0L5.447.947A3.252 3.252 0 00.85.956L.956.85a3.256 3.256 0 00-.009 4.597l16.994 16.994a1.003 1.003 0 010 1.424L.947 40.859a3.252 3.252 0 00.009 4.597L.85 45.35a3.256 3.256 0 004.597.009l16.994-16.994a1.003 1.003 0 011.424 0l16.994 16.994a3.252 3.252 0 004.597-.009l-.106.106a3.256 3.256 0 00.009-4.597L28.365 23.865a1.003 1.003 0 010-1.424L45.359 5.447z"
        })
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 66081:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"menu-item":"footer_menu-item__PuRF4","footer":"footer_footer__4Qyt9","inner":"footer_inner__ZnSSe","wrapper":"footer_wrapper__vsYp1","footer-menu":"footer_footer-menu__cG5mD"};

/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ }),

/***/ 90021:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"modal_backdrop__byYo9","overflow-visible":"modal_overflow-visible__Hw4yh","wrapper":"modal_wrapper__SOjyg","close-button":"modal_close-button__gm_NI","modal":"modal_modal__yslIq","body":"modal_body__ivFOU","header":"modal_header__nr_by","disclaimerModal":"modal_disclaimerModal__YCenG"};

/***/ })

}]);